import _ from 'underscore';
import Marionette from 'marionette';

export default Marionette.ItemView.extend({
	template: _.template('You do not have permission to access this page.')
});
